import { render, staticRenderFns } from "./PayrollDeductionsDetailsModal.vue?vue&type=template&id=62a0d456&scoped=true&"
import script from "./PayrollDeductionsDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PayrollDeductionsDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDeductionsDetailsModal.vue?vue&type=style&index=0&id=62a0d456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0d456",
  null
  
)

component.options.__file = "PayrollDeductionsDetailsModal.vue"
export default component.exports